module.exports = __webpack_public_path__ + "static/henho5-8d686645f1ba7c0922537b795c50f718.jpg";